import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
 fr: {
  when: "Quand",
  when1: "Le 2 novembre 2018",
  when2: "(c'est un vendredi !)",
  when3: "À partir de 14h45",
  where: "Où",
  where1: "Park Winters",
  where2: "27850 Co Rd 26",
  where3: "Winters, CA 95694",
  ma26ou: "Mathilde et Cyril",
  program: "Programme",
  hosting: "Hébergement",
  travel: "Transport",
  faq: "FAQ",
  contact: "Contact",
  rsvp: "RSVP",
  registry: "Liste",
  date: "Le 2 novembre 2018",
  location: "Winters, Californie",
  contactus: "Écrivez-nous à",
  date1: "02/11/2018",
  t1: "14h45",
  t2: "16h",
  t3: "18h",
  t4: "20h",
  t5: "1h",
  date2: "03/11/2018",
  t6: "10h",
  t7: "12h",
  t8: "18h",
  a1: "{0} Cérémonie",
  a2: "{0} Cocktail",
  a3: "{0} Dîner",
  a4: "{0} Fiesta",
  a5: "{0} Tous au lit !",
  a6: "{0} Brunch à {1}",
  a7: "{0} Après-midi sur la baie",
  a8: "{0} Apéro-dîner à {1}",
  home: "la maison",
  q1: "Où dormir la nuit du 1er au 2 novembre ?",
  q1r: "Si vous atterrissez le 1er novembre, vous pouvez soit dormir à Winters la nuit du 1er au 2, soit à San Francisco. Dans les deux cas, toute la gamme d'hôtels et d'Airbnb s'offre à vous.",
  q2: "Y a-t-il un thème au mariage ?",
  q2r: "Non, pas de thème particulier. Venez comme vous êtes.",
  q3: "Comment doit-on s'habiller ?",
  q3r: "Pas de dress-code, la seule règle c'est de vous sentir beau ! En revanche, passé le coucher de soleil (18h30), il a tendance à faire frais. Prévoyez de quoi vous couvrir si vous voulez profiter du jardin jusqu'à tard !",
  q4: "Que prévoit la météo ?",
  q4r: "Le 2 novembre 2017, il faisait ciel bleu et 21 degrés à Winters. On espère le même temps cette année ! Attention, il fait frais le soir, prenez de quoi vous couvrir.",
  q5: "Que faire si l'on a des allergies alimentaires ?",
  q5r: "Prévenez-nous avant le 1er octobre, le chef peut tout arranger !",
  q6: "Quand doit-on arriver à Winters ?",
  q6r: "On vous attend à Park Winters à 14h30. Vous pouvez arriver la veille à Winters, ou bien le jour même :) Il fera plus chaud à Winters qu'à San Francisco, mais il y a plus de choses à faire à San Francisco : à vous de voir.",
  q7: "Faut-il déjeuner avant le mariage ?",
  q7r: "Il y aura à manger dès 16h, on vous conseille de déjeuner léger.",
  q8: "Que faire avant ou après le mariage dans les environs ?",
  q8r: "Envoyez-nous un mail si vous voulez des recommandations. Il y a plein de choses à faire en dehors de San Francisco : Lac Tahoe, Napa & Sonoma Valley, Point Reyes, Stanford et la Silicon Valley, Los Angeles, Yosemite, etc.",
  q9: "Où peut-on manger à Winters ?",
  q9r: "On vous recommande {preserve}, qu'on a testé et retesté. C'est là où aura lieu le brunch le lendemain matin !",
  preserve: "Preserve",
  q10: "Dois-je apporter mon maillot de bain au mariage ?!",
  q10r: "Il y a piscine et jacuzzi sur le lieu du mariage, en libre accès. On vous encourage carrément à prendre votre maillot !",
  q11: "Peut-on fumer sur le lieu du mariage ?",
  q11r: "La loi californienne interdit de fumer dans les lieux publics, ce qui inclut les hôtels et restaurants, et Park Winters n'échappe pas à la règle. Il y aura un espace extérieur fumeur, assez restreint (mais hyper sympa) ; en revanche, il est interdit de fumer en dehors !",
  q12: "Où dormir la nuit du 3 au 4 novembre ?",
  q12r: "Si vous décidez de passer la soirée du 3 avec nous à San Francisco, nous vous recommandons soit de prendre un Airbnb dans la ville, soit de dormir à {stanyan} à deux pas de chez nous.",
  stanyan: "l'hôtel Stanyan Park",
  hotel: "On vous conseille de prendre une chambre au {0} : bon rapport qualité-prix, à moins de 15 minutes du lieu de mariage, et il y a de la place pour tout le monde, ce qui devrait faciliter l'organisation des trajets.",
  courtyard: "Courtyard Marriott de Vacaville",
  region: "Arriver dans la région depuis Paris",
  winters: "Arriver à Winters",
  quitter: "Arriver au mariage puis quitter le lieu",
  frenchbee: "Frenchbee (~550€) : départ d'Orly, arrivée à San Francisco",
  norwegian: "Norwegian Air (~650€) : départ de Roissy, arrivée à Oakland (plus près de Winters)",
  flights: "Sur Google Flights, vous pourrez comparer toutes les compagnies traditionnelles",
  rentalcars: "Un bon comparateur pour avoir une voiture à l'aéroport — évitez Fox, Thrifty et Dollar",
  turo: "Turo, le Drivy américain : location entre particuliers, tous les choix, tous les prix",
  ratp: "Hélas, la Californie est au niveau 0 du transport en commun... Rien à voir ici",
  fivestarlimo: "Five Star Limo : ils ont toutes les tailles, plus c'est gros, moins c'est cher",
  apilimos: "API Limos : à partir de $100 pour 8 à 14 personnes",
  checker: "Checker Cab, la compagnie de taxi locale — les avis en ligne sont mitigés",
  reco: "Notre suggestion",
  options: "Autres options",
 },
 en: {
  when: "When",
  when1: "November 2nd, 2018",
  when2: "(it's a Friday!)",
  when3: "Starting at 2:45pm",
  where: "Where",
  where1: "Park Winters",
  where2: "27850 Co Rd 26",
  where3: "Winters, CA 95694",
  ma26ou: "Mathilde + Cyril",
  program: "Program",
  hosting: "Accommodations",
  travel: "Travel",
  faq: "FAQ",
  contact: "Contact",
  rsvp: "RSVP",
  registry: "Registry",
  date: "11/2/18",
  location: "Winters, CA",
  contactus: "Send an email to",
  date1: "11/2/18",
  t1: "2:45pm",
  t2: "4pm",
  t3: "6pm",
  t4: "8pm",
  t5: "1am",
  date2: "11/3/18",
  t6: "10am",
  t7: "12pm",
  t8: "6pm",
  a1: "{0} Ceremony",
  a2: "{0} Cocktail",
  a3: "{0} Dinner",
  a4: "{0} Party",
  a5: "{0} Off to bed!",
  a6: "{0} Brunch at {1}",
  a7: "{0} Lazy afternoon in Tiburon",
  a8: "{0} Early dinner at {1}",
  home: "home",
  q1: "Where should we spend the night of the 1st of November?",
  q1r: "If you're landing on the 1st of November, you can either stay in Winters, or in San Francisco. In either case, there is a wide range of hotels and Airbnbs available.",
  q2: "Is there a theme to this wedding?",
  q2r: "No theme. Come as you are.",
  q3: "How should we dress?",
  q3r: "No dress-code, but one rule: feel handsome! That being said, after sunset (~6:30pm), the night gets cold. Make sure you have enough layers if you want to enjoy the outside!",
  q4: "What will the weather be like?",
  q4r: "On the 2nd of November, 2017, Winters had blue skies and 70 degrees. We're hoping for the same this year! Note, however, that nights get cold: pack some extra layers.",
  q5: "What can I do about my food allergies?",
  q5r: "You need to tell us before the 1st of October; the chef can accommodate everything!",
  q6: "When should we arrive in Winters?",
  q6r: "You're expected at Park Winters at 2:30pm. You can either arrive the day before in Winters, or the day of :) weather should be warmer in Winters than in San Francisco, but there's more to do and to see in SF: up to you!",
  q7: "Should we have lunch before the wedding?",
  q7r: "We'll start serving food at 4pm, we recommend a light lunch.",
  q8: "What should we do in the area, before or after the wedding?",
  q8r: "Send us an email and we'll send back recommendations. There's a ton of things to do outside of San Francisco: Lake Tahoe, Napa & Sonoma Valleys, Point Reyes, Stanford & the Silicon Valley, Los Angeles, Yosemite, etc.",
  q9: "Where should we eat in Winters?",
  q9r: "Hands down: {preserve}, tested and approved. That's where we'll brunch on the 3rd!",
  preserve: "Preserve",
  q10: "Should I pack my swimsuit?!",
  q10r: "There is a pool and a jaccuzzi in Park Winters. We strongly encourage you to bring a swimsuit!",
  q11: "Can we smoke in Park Winters?",
  q11r: "California law prohibits smoking in public spaces like hotels and restaurants, including venues like Park. There will be a dedicated, cosy smoking area, but no smoking will be permitted anywhere else.",
  q12: "Where should we spend the night of the 3rd of November?",
  q12r: "Assuming you don't have a place of your own in the city, and you'll be spending the evening of the 3rd at our place in San Francisco, we recommend either Airbnb or a stay at {stanyan}, two blocks from our apartment.",
  stanyan: "the Stanyan Park Hotel",
  hotel: "We recommend you stay at the {0} : nice rooms, good value, 15 minutes from the venue, and enough room to accommodate evereyone, which should make transportation arrangements easy.",
  courtyard: "Marriott Courtyard Hotel in Vacaville",
  region: "Getting there from France",
  winters: "Getting to Winters",
  quitter: "Getting to and leaving the venue",
  frenchbee: "Frenchbee: ~550€, from Orly airport to San Francisco airport",
  norwegian: "Norwegian Air: ~650€ from Roissy CDG aiport to Oakland airport (closer to Winters)",
  flights: "Google Flights, where you can compare all the traditional airlines",
  rentalcars: "A good car rental broker to get a car at the airport — stay away from Fox, Thrifty and Dollar",
  turo: "Turo: peer-to-peer ride sharing, cool product, all price ranges",
  ratp: "Alas, there is no good option to get to Winters with public transportation...",
  fivestarlimo: "Five Star Limo: all sizes, all prices, up to 20 people in a car",
  apilimos: "API Limos: starting at $100 for 8 to 14 people — tends to get more expensive for smaller cars",
  checker: "Checker Cab, the local taxi company — online reviews are... mixed",
  reco: "Our suggestion",
  options: "Other options",
 }
});

export default strings


// WEBPACK FOOTER //
// ./src/strings.js